import React from 'react';
import { Box, Typography, Paper } from '@mui/material';
import { StatCardProps } from './types';

const StatCard: React.FC<StatCardProps> = ({
  title,
  description,
  children,
  sx
}) => {
  return (
    <Paper
      sx={{
        width: '100%',
        background: 'rgba(26,27,53,0.95)',
        boxShadow: '0 0px 32px rgba(0, 0, 0, 0.8)',
        p: 1,
        m: 1,
        display: 'flex',
        flexDirection: 'column',
        borderRadius: '20px',  // Ajout d'un léger arrondi
        ...sx
      }}
    >
      <Box sx={{ mb: 1 }}>
        <Typography variant="h6" sx={{ color: '#68f1d1', fontWeight: 100 }}>
          {title}
        </Typography>
        {description && (
          <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.7)' }}>
            {description}
          </Typography>
        )}
      </Box>
      <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
        {children}
      </Box>
    </Paper>
  );
};

export default StatCard;
